import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { AppState } from '../../store';
import useStyles from './styles';
import { CopyButton } from '../common/copy-button';

const DeviceLabel = () => {
  const history = useHistory();
  const parameters: URLSearchParams = new URLSearchParams(history.location.search);
  const dealerCode: any = parameters.get('dealerCode') !== null ? parameters.get('dealerCode') : '';
  const vimsTransaction = parameters.get('vimsTransaction') || null;
  const device = useSelector((state: AppState) => !vimsTransaction ? state.search.selectedEntity : state.search.selectedVIMSEntity);
  const classes = useStyles();
  let labelContents = '';
  if (dealerCode.length > 0) {
    labelContents = `${dealerCode}: ${history.location.pathname.slice(
      history.location.pathname.lastIndexOf('/') + 1,
    )}`;
  } else if (device) {
    labelContents = `${device.deviceId || 'No associated device'}-${device.moduleType}-${device.assetSerialNumber
      }`;
  }
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <CopyButton copyData={device?.deviceId || 'No associated device'} />
      <Typography variant="h6" className={classes.deviceText}>
        {labelContents}
      </Typography>
    </Box>
  );
};
export default DeviceLabel;
